import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { api } from "./lib/api";
import { Toaster } from "./components/ui/sonner";
import { AuthProvider, useAuth } from "./context/AuthContext";
import AuthPages from "./pages/AuthPages";
import Dashboard from "./pages/Dashboard";
import AuditResults from "./pages/AuditResults";
import FindingSplitView from "./pages/FindingSplitView";
import ComparePage from "./pages/ComparePage";
import PublicStart from "./pages/PublicStart";
import AdminPage from "./pages/AdminPage";
import AdminUserDetail from "./pages/AdminUserDetail";
import LandingPage from "./pages/LandingPage";
import FlyerPage from "./pages/FlyerPage";
import { Loader2 } from "lucide-react";

const Protected = ({ children }) => {
  const { user } = useAuth();
  if (user === null)
    return <div className="flex min-h-screen items-center justify-center"><Loader2 className="h-8 w-8 animate-spin text-emerald-600" /></div>;
  if (user === false) return <Navigate to="/login" replace />;
  return children;
};

const DemoOrProtected = ({ children }) => {
  const { user } = useAuth();
  const { auditId } = useParams();
  const [demoId, setDemoId] = useState(undefined);
  useEffect(() => {
    api.get("/public/demo-audit").then((r) => setDemoId(r.data.audit_id)).catch(() => setDemoId(null));
  }, []);
  if (user === null || demoId === undefined)
    return <div className="flex min-h-screen items-center justify-center"><Loader2 className="h-8 w-8 animate-spin text-emerald-600" /></div>;
  if (user === false && auditId !== demoId) return <Navigate to="/login" replace />;
  return children;
};

const DemoRedirect = () => {
  const [target, setTarget] = useState(undefined);
  useEffect(() => {
    api.get("/public/demo-audit").then((r) => setTarget(r.data.audit_id)).catch(() => setTarget(null));
  }, []);
  if (target === undefined)
    return <div className="flex min-h-screen items-center justify-center"><Loader2 className="h-8 w-8 animate-spin text-emerald-600" /></div>;
  if (!target) return <Navigate to="/" replace />;
  return <Navigate to={`/audits/${target}`} replace />;
};

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<AuthPages mode="login" />} />
            <Route path="/register" element={<AuthPages mode="register" />} />
            <Route path="/forgot-password" element={<AuthPages mode="forgot" />} />
            <Route path="/reset-password" element={<AuthPages mode="reset" />} />
            <Route path="/start" element={<PublicStart />} />
            <Route path="/letak" element={<FlyerPage />} />
            <Route path="/ukazka" element={<DemoRedirect />} />
            <Route path="/admin" element={<Protected><AdminPage /></Protected>} />
            <Route path="/admin/users/:userId" element={<Protected><AdminUserDetail /></Protected>} />
            <Route path="/" element={<LandingPage />} />
            <Route path="/dashboard" element={<Protected><Dashboard /></Protected>} />
            <Route path="/audits/:auditId" element={<DemoOrProtected><AuditResults /></DemoOrProtected>} />
            <Route path="/audits/:auditId/findings/:findingId" element={<DemoOrProtected><FindingSplitView /></DemoOrProtected>} />
            <Route path="/compare/:aId/:bId" element={<Protected><ComparePage /></Protected>} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
